<template>
  <div>
    <div v-if="isLoading" class="loading-wrapper">
      §
    </div>
    <template v-else>
      <Breadcrumbs title="Главная страница"/>
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="page-grid">
              <div class="viewer mt-5 z-0">
                <b-form>
                  <div class="p-relative" v-if="renderImage">
                    <!-- Preview image -->
                    <img v-if="renderImage"
                         :src="renderImage"
                         class="render-image"
                         alt=""
                    />
                    <h1 id="render-title-for-banner">
                      {{mainModel.title.ru}}
                    </h1>
                    <p id="render-description-for-banner">
                      {{mainModel.description.ru}}
                    </p>
                  </div>

                  <!-- Desktop Image -->
                  <div class="d-flex mt-2">
                    <label class="form-label">Изображение для десктопа:</label>
                  </div>
                  <div class="d-flex mt-2">
                    <b-form-file id="select-image"
                                 ref="default"
                                 :disabled="!isEditor"
                                 placeholder="Кликните, чтобы выбрать изображение для десктопа"
                                 @change="changeFunction"
                                 browse-text="Выбрать"
                                 class="mr-2"
                    />
                    <b-button :disabled="!isEditor" variant="danger" @click="deleteBanner()">
                      Удалить
                    </b-button>
                  </div>

                  <!-- Mobile Image -->
                  <div class="d-flex mt-3">
                    <label class="form-label">Изображение для мобильных устройств:</label>
                  </div>
                  <div class="mobile-image-preview" v-if="renderMobileImage">
                    <img :src="renderMobileImage" class="mobile-preview-img" alt="Mobile preview" />
                  </div>
                  <div class="d-flex mt-2">
                    <b-form-file id="select-mobile-image"
                                 ref="mobile"
                                 :disabled="!isEditor"
                                 placeholder="Кликните, чтобы выбрать изображение для мобильных"
                                 @change="changeMobileFunction"
                                 browse-text="Выбрать"
                                 class="mr-2"
                    />
                    <b-button :disabled="!isEditor" variant="danger" @click="deleteMobileBanner()">
                      Удалить
                    </b-button>
                  </div>
                </b-form>
              </div>
              <div class="actions">
                <template v-if="!isEditor">
                  <b-button variant="info" @click="isEditor = true">
                    Изменить
                  </b-button>

                </template>
                <template v-else>
                  <b-button @click="isEditor = false"
                            variant="dark">
                    Отменить редактирование
                  </b-button>
                  <b-button variant="secondary" @click="resetEditData">
                    Сбросить изменения
                  </b-button>
                  <b-button variant="success"
                            @click="updateMainBannerData">
                    Сохранить изменения
                  </b-button>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import api from "@/api/api";
import {LanguageAdapterMixin} from "@/mixins/Language/LanguageAdapterMixin";
import image from '@/assets/images/backgroundMain.webp'
import Vue from "vue";
// import image from "@/assets/images/backgroundMain.webp";
export default {
  name: 'MainBannerPage',
  mixins: [LanguageAdapterMixin],
  data() {
    return {
      isLoading: true,
      isEditor: false,
      oldMainModel: '',
      mainModel: {
        image: { original_url: '' },
        mobileImage: { original_url: '', shouldDelete: false },
        title: {
          ru: '',
          en: '',
          uz: '',
          kk: '',
        },
        description: {
          ru: '',
          en: '',
          uz: '',
          kk: '',
        },
      },
    }
  },
  computed: {
    renderImage() {
      if (this.mainModel?.image?.['original_url']) {
        if (typeof this.mainModel?.image?.['original_url'] === 'object') {
          return URL.createObjectURL(this.mainModel?.image['original_url'])
        }
        return this.mainModel?.image['original_url']
      }
      return ''
    },
    renderMobileImage() {
      // Не показываем изображение если оно помечено для удаления
      if (this.mainModel?.mobileImage?.shouldDelete) {
        return ''
      }

      if (this.mainModel?.mobileImage?.['original_url']) {
        if (typeof this.mainModel?.mobileImage?.['original_url'] === 'object') {
          return URL.createObjectURL(this.mainModel?.mobileImage['original_url'])
        }
        return this.mainModel?.mobileImage['original_url']
      }
      return ''
    },
  },
  methods: {
    async getMainBannerData() {
      this.mainModel = (await api.mainBanner.get()).data['main_banner']

      if (this.mainModel?.image?.original_url === undefined) {
        this.$set(this.mainModel, 'image', { original_url: '' })
      }
      if (this.mainModel?.mobileImage?.original_url === undefined) {
        this.$set(this.mainModel, 'mobileImage', { original_url: '', shouldDelete: false })
      } else if (this.mainModel?.mobileImage && !this.mainModel.mobileImage.hasOwnProperty('shouldDelete')) {
        this.$set(this.mainModel.mobileImage, 'shouldDelete', false)
      }

      // Сохраняем oldMainModel без служебных полей
      const modelCopy = JSON.parse(JSON.stringify(this.mainModel))
      if (modelCopy.mobileImage) {
        delete modelCopy.mobileImage.shouldDelete
      }
      this.oldMainModel = JSON.stringify(modelCopy)

      this.isLoading = false
    },
    async updateMainBannerData() {
      try {
        this.isLoading = true
        const sendBody = new FormData()
        Object.entries(this.mainModel).forEach(([key, value]) => {
          if (key === 'image') {
            const imageFile = this.$refs.default.$el.children[0].files[0]
            if (imageFile) sendBody.append(key, imageFile)
            return
          }
          if (key === 'mobileImage') {
            const mobileImageFile = this.$refs.mobile.$el.children[0].files[0]
            if (mobileImageFile) {
              sendBody.append('mobile_image', mobileImageFile)
            } else if (this.mainModel.mobileImage.shouldDelete) {
              // Создаем минимальное прозрачное PNG изображение 1x1
              const base64Data = 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg=='
              const binaryString = window.atob(base64Data)
              const bytes = new Uint8Array(binaryString.length)
              for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i)
              }
              const blob = new Blob([bytes], { type: 'image/png' })
              const deleteFile = new File([blob], 'delete.png', { type: 'image/png' })
              sendBody.append('mobile_image', deleteFile)
            }
            return
          }
          sendBody.append(key, value || '')
        })
        Object.entries(this.mainModel.title).forEach(([key, value]) => sendBody.append(`title[${key}]`, value || ''))
        Object.entries(this.mainModel.description).forEach(([key, value]) => sendBody.append(`description[${key}]`, value || ''))

        // Отладочная информация
        console.log('FormData contents:')
        for (let pair of sendBody.entries()) {
          console.log(pair[0] + ': ' + pair[1])
        }

        await api.mainBanner.update(sendBody)
      } catch (e) {
        Vue.toasted.error("Не удалось обновить", {
          position: 'top-right',
          duration: 3000
        });
      } finally {
        await this.getMainBannerData()
        this.isEditor = false
        this.isLoading = false
      }
    },
    async resetEditData() {
      this.mainModel = JSON.parse(this.oldMainModel)
      // Восстанавливаем служебные поля
      if (this.mainModel.mobileImage && !this.mainModel.mobileImage.hasOwnProperty('shouldDelete')) {
        this.$set(this.mainModel.mobileImage, 'shouldDelete', false)
      }
    },
    async deleteBanner() {
      let image = require('@/assets/images/backgroundMain.webp')

      // Getting file in binary format to retype blob
      const response = await fetch(image, { method: 'GET' }).then((res) => res.blob())
      // Rerecording type File
      const newFile = new File([response], 'test.webp')

      // Set default image in html input for request
      let container = new DataTransfer();
      container.items.add(newFile);
      this.$refs.default.$el.children[0].files = container.files;

      // Set default image for preview for user
      this.mainModel.image.original_url = image
    },
    async deleteMobileBanner() {
      // Очищаем поле мобильного изображения
      this.mainModel.mobileImage = {
        original_url: '',
        shouldDelete: true
      }

      // Очищаем input файла
      if (this.$refs.mobile && this.$refs.mobile.$el.children[0]) {
        this.$refs.mobile.$el.children[0].value = ''
      }
    },
    changeFunction(event) {
      this.mainModel.image.original_url = event.target.files[0]
    },
    changeMobileFunction(event) {
      this.mainModel.mobileImage.original_url = event.target.files[0]
      // Сбрасываем флаг удаления при выборе нового файла
      this.mainModel.mobileImage.shouldDelete = false
    }
  },
  mounted() {
    (async () => {
      await this.getMainBannerData()
    })()
  },

  watch: {
    'mainModel.styles': {
      deep: true,
      immediate: true,
      handler() {
        const stylesSelector = document.getElementById('styles-for-main-banner')
        stylesSelector.innerHTML = this.mainModel.styles
      }
    }
  }
}
</script>

<style scoped lang="scss">
.loading-wrapper {
  min-height: calc(100vh - 180px);
  display: flex;
  align-items: center;
  justify-content: center;

  & > .spinner {
    scale: 2;
  }
}

.page-grid {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;

  .actions {
    z-index: 3;
    justify-self: end;

    display: grid;
    grid-template-columns: 100%;
    gap: 15px;
    height: fit-content;

    & > * {
      min-width: 200px;
    }
  }

  .render-image {
    width: 200%;
  }
  #render-title-for-banner {
    position: absolute;
    top: 20%;
    left: 20%;
  }
  #render-description-for-banner {
    position: absolute;
    top: 60%;
    left: 20%;
  }
}

.mobile-image-preview {
  margin-top: 10px;
  margin-bottom: 10px;

  .mobile-preview-img {
    max-width: 300px;
    max-height: 200px;
    border: 1px solid #ddd;
    border-radius: 4px;
    object-fit: cover;
  }
}

.form-label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.5rem;
}
</style>